import { getCsrfToken } from '../api/csrf';
import { STORAGE_KEYS } from '../api/config';

export const SESSION_ACTIVE_KEY = 'agrosaf_session_active';

export const setSessionActive = () => {
  sessionStorage.setItem(SESSION_ACTIVE_KEY, 'true');
};

export const clearSessionActive = () => {
  sessionStorage.removeItem(SESSION_ACTIVE_KEY);
};

const PUBLIC_ROUTE_PREFIXES = [
  '/career',
  '/job-application',
  '/login',
  '/public/',
  '/policy_library/acknowledgment/',
  '/linkedin/callback',
  '/api/offer/',
  '/offer-acceptance/',
  '/orientation/invite/',
];

export const isPublicRoute = (pathname = window.location.pathname) =>
  PUBLIC_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix)
  );

export const hasSessionHint = () => {
  if (!isPublicRoute()) {
    return true;
  }
  if (localStorage.getItem(STORAGE_KEYS.REMEMBER_ME) === 'true') {
    return true;
  }
  if (sessionStorage.getItem(SESSION_ACTIVE_KEY) === 'true') {
    return true;
  }
  return Boolean(getCsrfToken());
};

/** Skip the initial /auth/me probe on public pages for anonymous visitors. */
export const shouldProbeSessionOnLoad = () => {
  if (!isPublicRoute()) {
    return true;
  }
  return hasSessionHint();
};
